// import { atom, selector, selectorFamily } from 'recoil';
import { COMPANY_API, source } from 'apis';
import { delay, clone } from 'utils';
import { service } from 'config/menuList';
import storage from 'helpers/storage';

export interface IService {
  serviceType: 'SIKDAE' | 'QUICK' | 'FLOWER';
  status: 'DISABLED' | 'ACTIVE' | 'INACTIVE';
  updateUserId?: string;
  updateDate?: string;
  agreeUserId?: string;
  agreeDate?: string;
}

export interface ICompanyInfo {
  comId: string;
  name: string;
  serviceList: Array<IService>;
}

export interface IUser {
  id: string;
  captainPaymentGrade: 'USER' | 'ADMIN' | 'SUPER';
  name: string;
  company?;
}

export interface IMenu {
  idx: number;
  name: string;
  depth: string;
  sort: string;
  creatAllow: boolean;
  readAllow: boolean;
  updateAllow: boolean;
  deleteAllow: boolean;
  url?: string;
  parentMenuIdx?: number;
}

export interface IServiceMenu {
  serviceType: 'QUICK' | 'FLOWER' | 'MANAGE' | 'WELFARE';
  menuList?: Array<IMenu>;
}

export interface IMeInfo {
  user: IUser;
  companyInfo: ICompanyInfo;
  serviceMenuList: Array<IServiceMenu>;
  auth?;
  company?;
}

const replaceServiceType = (serviceType) =>
  serviceType === 'MANAGE' ? `${serviceType.toLowerCase()}ment` : serviceType.toLowerCase();
const compareSort = function(a, b) {
  if (a.sort > b.sort) {
    return 1;
  }
  if (a.sort < b.sort) {
    return -1;
  }
  // a must be equal to b
  return 0;
};
const idMapping = (data, key) => data.reduce((acc, e, i) => ({ ...acc, [e[key]]: i }), {});
const setMenuListTree = (menuList = [], serviceRoutesMap) => {
  const menus = menuList
    .filter((e) => serviceRoutesMap[e.idx])
    .map((e) => {
      const route = serviceRoutesMap[e.idx];
      return {
        ...e,
        ...route
      };
    });
  const loot = [];
  const mapping = idMapping(menus, 'idx');
  // eslint-disable-next-line no-restricted-syntax
  for (const menu of menus) {
    if (!menu.parentMenuIdx) {
      loot.push(menu);
    } else {
      const parent = menus[mapping[menu.parentMenuIdx]];
      parent.children = [...(parent.children || []), menu].sort(compareSort);
    }
  }
  return loot.sort(compareSort);
};

const platServiceMenus = (serviceType: 'QUICK' | 'FLOWER' | 'MANAGE' | 'WELFARE') => {
  const menus = service[replaceServiceType(serviceType)] || [];
  return menus.reduce((a, c) => {
    const { children, ...p } = c;
    if (children) {
      const sub = children.reduce((acc, curr) => ({ ...acc, [curr.idx]: curr }), {});
      return {
        ...a,
        [c.idx]: p,
        ...sub
      };
    }
    return { ...a, [c.idx]: c };
  }, {});
};

// export const meInfoState = atom<IMeInfo>({
//   key: 'MeInfoState',
//   default: {
//     user: {
//       id: '',
//       captainPaymentGrade: null,
//       name: '',
//       company: {}
//     },
//     companyInfo: null,
//     serviceMenuList: [],
//     auth: {},
//     company: []
//   }
// });

// export const userState = selector<IUser>({
//   key: 'UserState',
//   get: ({ get }) => {
//     const { user } = get(meInfoState);
//     return user;
//   }
// });

// export const captainPaymentPermissionState = selector<'USER' | 'ADMIN' | 'SUPER'>({
//   key: 'CaptainPaymentPermissionState',
//   get: ({ get }) => {
//     const user = get(userState);
//     return user.captainPaymentGrade;
//   }
// });

// export const companyState = selector<ICompanyInfo>({
//   key: 'CompanyState',
//   get: ({ get }) => {
//     const { companyInfo } = get(meInfoState);
//     return companyInfo;
//   }
// });

// export const serviceMenusState = selector<object>({
//   key: 'ServiceMenusState',
//   get: ({ get }) => {
//     const { serviceMenuList } = get(meInfoState);

//     return serviceMenuList.reduce(
//       (a, m) => ({
//         ...a,
//         [replaceServiceType(m.serviceType)]: setMenuListTree(m.menuList, platServiceMenus(m.serviceType))
//       }),
//       {}
//     );
//   }
// });

export const serviceMenusAPI = async () => {
  const result = await COMPANY_API.get(`captain-payment/pass/v1/me`, { cancelToken: source.token });
  const { serviceMenuList, companyInfo } = result.data;
  storage.set('userCount', { userCount: companyInfo.userCount });
  storage.set('companyInfo', { ...companyInfo });

  return serviceMenuList.reduce(
    (a, m) => ({
      ...a,
      [replaceServiceType(m.serviceType)]: setMenuListTree(m.menuList, platServiceMenus(m.serviceType))
    }),
    {}
  );
};

// export const meInfoQuery = selectorFamily({
//   key: 'MeInfoQuery',
//   get: (userId: string) => async () => {
//     if (!userId) return null;
//     const result = await COMPANY_API.get(`captain-payment/pass/v1/me`);
//     return result.data;
//   }
// });

// export const mealServiceQuery = selectorFamily({
//   key: 'UserQuery',
//   get: (userId: string) => async () => {
//     if (!userId) return null;
//     const result = await COMPANY_API.get(`captain-payment/pass/v1/service/sikdea`);
//     return result.data;
//   }
// });
